import { render, staticRenderFns } from "./ChoseStaff.vue?vue&type=template&id=09bac3a2&"
import script from "./ChoseStaff.vue?vue&type=script&lang=js&"
export * from "./ChoseStaff.vue?vue&type=script&lang=js&"
import style0 from "./ChoseStaff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports